<template>
  <component
    :is="logoComponent"
    :width="width"
    :height="height"
    v-bind="logoProps"
  />
</template>

<script>
import { useBrand } from "@/composables/useBrand";

export default {
  name: "LogoProvider",
  components: {
    DbpLogoNoPayoff: () => import("@/components/svg/dbp/DbpLogoNoPayoff.vue"),
    DsrLogoNoPayoff: () => import("@/components/svg/dsr/DsrLogoNoPayoff.vue"),
    DbpLogoSvg: () => import("@/components/svg/dbp/DbpLogoSvg.vue"),
    DsrLogoSvg: () => import("@/components/svg/dsr/DsrLogoSvg.vue"),
  },
  props: {
    width: {
      type: [String, Number],
      default: "200px",
    },
    height: {
      type: [String, Number],
      default: "200px",
    },
    colors: {
      type: Array,
      default: () => ["#1a67f8", "#050d21"],
    },
    showPayoff: {
      type: Boolean,
      default: false,
    },
    isDsr: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    const { isDsr: isDsrBrand } = useBrand();
    return { isDsrBrand };
  },
  computed: {
    isDsrResolved() {
      return this.isDsr !== null ? this.isDsr : this.isDsrBrand;
    },
    logoComponent() {
      if (this.isDsrResolved) {
        return this.showPayoff ? "DsrLogoSvg" : "DsrLogoNoPayoff";
      }
      return this.showPayoff ? "DbpLogoSvg" : "DbpLogoNoPayoff";
    },
    logoProps() {
      return this.showPayoff ? {} : { colors: this.colorsComputed };
    },
    colorsComputed() {
      const colors = [...this.colors];
      colors[0] = this.isDsrResolved ? "#55d400" : "#1a67f8";
      return colors;
    },
  },
};
</script>
